import { returnAllTradeDetailsFromGenericParams } from "@/lib/agGridColDefs/colDefGlobalHelpers";
import { returnFormattedDate } from "@/lib/globalFormatterHelper";
import { InstrumentTypeCode } from "@/lib/interfaces and Enums/ENUMInstrumentTypeCode";

const ExpiryDateCellRenderer = (props: any) => {
  const { isOp, isOutright, isLeg } =
    returnAllTradeDetailsFromGenericParams(props);

  const fullTradeData = props.fullTradeData;

  const instrumentType = isOp
    ? isOutright
      ? fullTradeData.executionRequestCounterParties?.[0]?.legs?.[0]?.instrumentType
      : props.data.instrumentType
    : isOutright
      ? fullTradeData.legs?.[0]?.instrumentType
      : props.data.instrumentType;

  let expiryDateToReturn = "";

  if (isLeg) {
    expiryDateToReturn = props.value;
  }

  //get value for outright trades
  if (isOutright && !isOp) {
    expiryDateToReturn = props.fullTradeData.legs?.[0]?.expiryDate;
  } else if (isOutright && isOp) {
    expiryDateToReturn = props.data.legs?.[0]?.expiryDate;
  }

  if (instrumentType != InstrumentTypeCode.OPT) {
    expiryDateToReturn = "";
  }

  return (
    <div data-testid="expiryDateContainer">
      {expiryDateToReturn ? returnFormattedDate(expiryDateToReturn) : ""}
    </div>
  );
};

export default ExpiryDateCellRenderer;
